var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionTitle',{attrs:{"title":_vm.$tc('note', 1)}}),_c('div',{staticClass:"mb-5",staticStyle:{"white-space":"pre-line"}},[_vm._v(" "+_vm._s(_vm.company.remarks ? _vm.company.remarks : "N/A")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }